import { get, map } from 'lodash';

const mapGeography = (places) => map(places, (place = {}) => ({
  id: place.id,
  state: place.state,
  name: get(place, 'name', '').concat(', ', place.state),
}));

export default mapGeography;
